export const submitGameScore = (body) => {

    const request = {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    };

    return fetch("/api/games/scores", request)
        .then(res => res.json().then(data => ({ status: res.status, body: data })))
        .catch(err => ({ status: 0, body: { error: true, error_message: err && err.message } }));

};
